module.exports = __webpack_public_path__ + "img/组 6033.7d3448ce.svg";